<ion-app  *ngIf="keyLoaded">
  <ion-router-outlet></ion-router-outlet>
</ion-app>
<!---APP LOADER-->
<app-loader></app-loader>